import React from 'react';
import { Button, Spin, Alert } from 'antd';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import './profileDetailsView.scss';
import ProfileHeader from './ProfileHeader';
import ProfileDetailsCards from './ProfileDetailsCards';

const ProfileDetailsView = ({
  className = '',
  profileData,
  onBack,
  onConfirm,
  loading = false,
  showBackButton = true,
  showConfirmButton = true,
  title = "Details View",
  customActions = null
}) => {
  
  const location = useLocation();
  const navigate = useNavigate();

  // Handle back button click with smart navigation
  const handleBackClick = () => {
  
    const pathParts = location.pathname.split('/');
    
    // Check if we're on profile-creation page with an ID
    if (pathParts[1] === 'profile-creation' && pathParts[2]) {
      // If there's an ID in the URL, call the onBack prop (which has the edit logic)
      // or navigate to profile-creation without ID
      if (onBack && typeof onBack === 'function') {
        onBack();
      } else {
        navigate('/profile-creation');
      }
    } else if (pathParts[1] === 'profile-details' && pathParts[2]) {
      // Navigate to profile-creation with the same ID
      navigate(`/profile-creation/${pathParts[2]}`);
    } else {
      // Default: use onBack callback if provided, otherwise go back
      if (onBack && typeof onBack === 'function') {
        onBack();
      } else {
        navigate(-1);
      }
    }
  };

  if (loading) {
    return (
      <div className="profile_details_loading">
        <Spin size="large" />
        <p>Creating profile...</p>
      </div>
    );
  }

  if (!profileData) {
    return (
      <div className="profile_details_error">
        <Alert
          message="No Profile Data"
          description="Profile data not found. Please go back and submit the form again."
          type="error"
          showIcon
        />
        <Button type="primary" onClick={handleBackClick} style={{ marginTop: '20px' }}>
          Go Back
        </Button>
      </div>
    );
  }

  return (
    <div className={`profile_details_view ${className}`}>
      {/* Header */}

      {/* Main Content */}
      <div className="profile_content">
        {/* Profile Header Section */}
        <ProfileHeader profileData={profileData} type='profile_details_view' profileImagePosition='left' />

        {/* Information Cards */}
        <ProfileDetailsCards profileData={profileData} loading={loading} />
        

        {/* Footer Actions */}
        <div className="profile_actions">
          {showBackButton && (
            <Button
              className="action_btn wide mb back_btn"
              onClick={handleBackClick}
              type="primary"
            >
              Back
            </Button>
          )}
          {showConfirmButton && (
            <Button
              type="primary"
              className="action_btn wide mb confirm_btn"
              onClick={onConfirm}
            >
              Confirm
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

ProfileDetailsView.propTypes = {
  profileData: PropTypes.object,
  onBack: PropTypes.func,
  onConfirm: PropTypes.func,
  loading: PropTypes.bool,
  showBackButton: PropTypes.bool,
  showConfirmButton: PropTypes.bool,
  title: PropTypes.string,
  customActions: PropTypes.node
};

ProfileDetailsView.defaultProps = {
  profileData: null,
  onBack: () => {},
  onConfirm: () => {},
  loading: false,
  showBackButton: true,
  showConfirmButton: true,
  title: "Details View",
  customActions: null
};

export default ProfileDetailsView;
